import { ClassValue } from 'classnames'
import React from 'react'
import { AdType } from '../../config'
import { Intent } from '../../types/badges'
import { BaseBadge } from './BaseBadge'

const adTypeOptions: { [key: string | number]: { text: string; intent: Intent } } = {
    [AdType.SponsoredProducts]: { text: 'Sponsored Products', intent: 'success' },
}

interface AdTypeBadgeProps {
    type?: number // SP
    className?: ClassValue
}

export const AdTypeBadge = ({ type = 1, className }: AdTypeBadgeProps) => {
    return <BaseBadge options={adTypeOptions} value={type} className={className} />
}
